let resolve;
let reject;
const p = new Promise((r, rej) => {
  resolve = r;
  reject = rej;
});

let intervalId;
let timeoutId;

const init = (d, s, id) => {
  const rjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {
    return;
  }
  const js = d.createElement(s); js.id = id;
  js.src = `https://www.google.com/recaptcha/api.js?render=${window.CONFIG.recaptcha}`;
  rjs.parentNode.insertBefore(js, rjs);
  js.onload = () => {
    intervalId = setInterval(
      () => {
        if (!window.grecaptcha.ready) {
          reject(new Error('Recaptcha initialize failed'));
          return;
        }
        clearInterval(intervalId);
        clearTimeout(timeoutId);

        window.grecaptcha.ready(resolve);
      },
      500,
    );
    timeoutId = setTimeout(() => {
      clearInterval(intervalId);
    }, 5000);
  };
  js.onerror = () => {
    reject(new Error('Recaptcha script loaded with error'));
  };
};
init(document, 'script', 'recaptcha-v3-sdk');

// (function(d, s, id) {
//   const fjs = d.getElementsByTagName(s)[0]
//   if (d.getElementById(id)) {
//     return
//   }
//   const js = d.createElement(s); js.id = id
//   js.src = '//connect.facebook.net/en_US/sdk.js'
//   fjs.parentNode.insertBefore(js, fjs)
// }(document, 'script', 'facebook-jssdk'))

export const recaptcha = () => Promise.resolve(p);
export default recaptcha;

